import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";
import type { Section } from "./useSectionSelector";

const i18nRoot = "settings.workflows.form";

interface SectionsResponse {
  records: Section[];
}

export const useFetchSections = ({ name }: { name: string }) => {
  const { error } = useToast();

  return useQuery(
    ["workflows", "list", "sections", name],
    () =>
      reactQueryGet<SectionsResponse>(
        internalApi.settings.courses.sections.index({ params: { name } }),
      ),
    {
      onError: () => error(t([i18nRoot, "errors", "sections", "fetch_failed"])),
    },
  );
};
